// UTTIL FUNCTION FOR SETTING TOKEN TO LOCALSTORAGE
const setAuthToken = (token) => {
  if (token) {
    localStorage.setItem("token", token);
  } else {
    localStorage.removeItem("token");
  }
};

export default setAuthToken;
